<template>
  <v-card flat class="quiz-component">
    <answers-header :activity="activity" :activity-index="activityIndex" />
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <p>{{ activity.logged_answers.data }}</p>
    <p
      v-for="(a, index) in activity.logged_answers"
      :key="index"
      class="answer"
    >
      <v-icon v-if="a.is_correct" class="icon-answer" color="correct">
        done
      </v-icon>
      <v-icon v-else class="icon-answer" color="incorrect">close</v-icon>
      <em>{{ a.data }}</em>
      <span v-if="a.data === activity.answer.data"> [Chosen by student]</span>
    </p>
    <v-card-actions>
      <v-spacer />
      <div
        :class="[
          'result-chip',
          activity.answer.is_correct ? 'correct' : 'incorrect'
        ]"
      >
        <div class="icon-container">
          <v-icon color="white" class="icon">{{
            activity.answer.is_correct ? 'check' : 'close'
          }}</v-icon>
        </div>
        <span>{{ activity.answer.is_correct ? 'CORRECT' : 'INCORRECT' }}</span>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import AnswersHeader from './AnswersHeader'

export default {
  name: 'QuizLessonResult',
  components: {
    AnswersHeader
  },
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.quiz-component {
  background: transparent;

  .answer {
    > * {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
    span {
      font-size: 12px;
      line-height: 20px;
    }

    em {
      font-size: 16px;
      font-style: normal;
      margin-right: 10px;
    }
    .icon-answer {
      font-size: 18px;
    }
  }

  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }

  .result-chip {
    position: relative;
    border: 1px solid #ccc;
    width: 130px;

    &.correct {
      background-color: white !important;
      .icon-container {
        background: var(--v-correct-base);
      }
    }
    &.incorrect {
      background-color: white !important;
      .icon-container {
        background: var(--v-incorrect-base);
      }
    }
    .icon-container {
      width: 35px;
      height: 35px;
      position: relative;
      display: inline-block;
      vertical-align: middle;
      .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    span {
      display: inline-block;
      vertical-align: middle;
      line-height: 35px;
      text-align: center;
      width: 90px;
    }
  }
}
</style>
